import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=1a958d0d&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=1a958d0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a958d0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a958d0d')) {
      api.createRecord('1a958d0d', component.options)
    } else {
      api.reload('1a958d0d', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=1a958d0d&scoped=true&", function () {
      api.rerender('1a958d0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TmjCJ8aAlx5B/JS/teamMember.vue"
export default component.exports